import { constants, typographyStyles } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";

const { colors } = constants;
const { textMObj } = typographyStyles;

const greenWithOpacity = `${colors.ui.green[400]}15`;

export const testCss: CSSObject = {
  backgroundColor: greenWithOpacity,
};

export const containerCss = {
  marginBottom: "24px",
  listStyleType: "none",
};

export const multipleChoiceContainerCss = (
  isReadAloudButtonActive: boolean,
) => ({
  position: "relative",
  backgroundColor: colors.ui.neutral[25],
  borderRadius: isReadAloudButtonActive ? "4px 4px 0px 0px" : "4px",
});

export const multipleChoiceCss: CSSObject = {
  display: "flex",
  position: "relative",
  color: colors.ui.neutral[500],
  padding: "12px 16px",
};

export const multipleChoiceBackgroundCss = (
  isCorrectChoice: boolean | null,
  shouldRenderDefaultBackground: boolean,
) => {
  if (shouldRenderDefaultBackground) {
    return { backgroundColor: colors.ui.neutral[25] };
  }

  return {
    backgroundColor: isCorrectChoice ? greenWithOpacity : colors.ui.neutral[50],
  };
};

export const choiceLetterCss: CSSObject = {
  ...textMObj,
  fontWeight: "bold",
  marginRight: "16px",
};

export const choiceTextCss: CSSObject = {
  ...textMObj,
  whiteSpace: "pre-line",

  p: {
    margin: 0,
  },
};

export const multipleChoiceLabelCss: CSSObject = {
  position: "absolute",
  top: "-10px",
  left: "42px",
  fontWeight: "bold",
};
